import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const QualityChecksModal = ({ pointsSummary = {}, isModalOpen, toggle }) => {

  
  const passedFailed = (value) => {
    return {
      label: value === 1 ? "Passed" : "Failed",
      style: {
        padding: "4px 10px",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "600",
        backgroundColor: value === 1 ? "#DCFCE7" : "#FEE2E2",
        color: value === 1 ? "#166534" : "#991B1B",
      },
    };
  };

  const basePoints = Number(pointsSummary.basePoints && pointsSummary.basePoints ? 50: 0);
  const qcPoints = Number(
    pointsSummary.qualityChecks && pointsSummary.qualityChecks.pointsAwarded ? pointsSummary.qualityChecks.pointsAwarded : 0
  );

  const totalPoints = basePoints + qcPoints;

  const attention = passedFailed(pointsSummary.qualityChecks?.attentionScore);
  const time = passedFailed(pointsSummary.qualityChecks?.timeScore);
  const profile = passedFailed(pointsSummary.qualityChecks?.profileScore);

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    borderRadius: "10px",
    background: "#fff",
    border: "1px solid #e5e7eb",
    color: "#6b7280",
  };

  return (
    <Modal isOpen={isModalOpen} toggle={toggle} centered>
      
      <ModalHeader
        toggle={toggle}
        style={{
          background: "#0069AB",
          color: "#fff",
          borderBottom: "none",
        }}
      >
        <div>
          <div style={{ fontSize: "18px", fontWeight: "700" }}>
            Points Summary
          </div>
          <div style={{ fontSize: "12px", opacity: 0.8 }}>
            Points Calculation Breakdown
          </div>
        </div>
      </ModalHeader>

      <ModalBody style={{ background: "#f9fafb", padding: "16px" }}>
        
        {/* TOTAL CARD */}
        <div
          style={{
            background: "#fff",
            borderRadius: "14px",
            padding: "16px",
            textAlign: "center",
            marginBottom: "14px",
            border: "1px solid #e5e7eb",
          }}
        >
          <div style={{ fontSize: "12px", color: "#6b7280" }}>
            Total Points
          </div>
          <div
            style={{
              fontSize: "32px",
              fontWeight: "800",
              margin: "5px 0",
              color: "#000",
            }}
          >
            {totalPoints}
          </div>
          {/* <div style={{ fontSize: "12px", color: "#6b7280" }}>
            Base Points + Quality Check Points
          </div> */}
        </div>

        {/* ROWS */}
       {pointsSummary.qualityChecks && <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          
          <div style={rowStyle}>
            <span>Base Points</span>
            <strong>{basePoints}</strong>
          </div>

          <div style={rowStyle}>
            <span>Attention Check</span>
            <span style={attention.style}>{attention.label}</span>
          </div>

          <div style={rowStyle}>
            <span>Time Check</span>
            <span style={time.style}>{time.label}</span>
          </div>

          <div style={rowStyle}>
            <span>Profile Check</span>
            <span style={profile.style}>{profile.label}</span>
          </div>

          <div
            style={{
              ...rowStyle,
              background: "#EEF2FF",
              border: "1px solid #C7D2FE",
            }}
          >
            <span>Quality Check Points</span>
            <strong>{qcPoints}</strong>
          </div>

        </div>}
      </ModalBody>

      <ModalFooter style={{ borderTop: "none" }}>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default QualityChecksModal;